import { IScriptLinkObject } from "../../../../../domain/editableFormat/objects";
import { IScriptLinkObjectBean } from "../../beans/objects";
import { AbstractObjectTranslator } from "./AbstractObjectTranslator";
import {
  InputRuleBehaviorTranslator,
  LinkedScriptExecuteBehaviorTranslator,
  RelationReplacer,
 } from "./properties";
import { TextDrawableObjectTranslator } from "./base";

export class ScriptLinkObjectTranslator extends AbstractObjectTranslator<IScriptLinkObject, IScriptLinkObjectBean> {
  constructor() {
    super(new TextDrawableObjectTranslator());
  }

  protected shouldRecordName(source: IScriptLinkObjectBean): boolean {
    return true;
  }

  overwriteObject(source: IScriptLinkObject, bean: IScriptLinkObjectBean, formatId: number): void {
    source.inputRuleBehavior = this.inputRuleBehavior.from(bean);
    // @ext-keyは対応しない.(大昔にがん登録向けに実装していたが実際に使われてはいない模様.今となってはどう使うかの想定も不明.)
    source.scriptExecuteBehavior = this.scriptExecuteBehavior.from(bean);
  }

  overwriteBean(source: IScriptLinkObjectBean, object: IScriptLinkObject): void {
    source["@type"] = "1";
    source["@data-validation"] = this.inputRuleBehavior.to(object).dataValidation;
    // source["@input-code"] = this.inputMethodBehavior.to(object).inputCode;
    // @ext-keyは対応しない.(大昔にがん登録向けに実装していたが実際に使われてはいない模様.今となってはどう使うかの想定も不明.)
    const scriptExecuteBehavior = this.scriptExecuteBehavior.to(object.scriptExecuteBehavior);
    source["@exe-path"] = scriptExecuteBehavior.exePath;
    source["@csv-path"] = scriptExecuteBehavior.csvPath;
    source["@update"] = scriptExecuteBehavior.update;
    source["@split"] = scriptExecuteBehavior.split;
    source["@before-value"] = undefined;  // フォーマット編集では設定しない.(文書編集用.)
    source["@before-value-path"] = scriptExecuteBehavior.beforeValuePath;
    source["@value-path"] = scriptExecuteBehavior.valuePath;
    source.scriptitem = scriptExecuteBehavior.scriptitem;
    this.relationReplacer.replaceBeans(
      source,
      "script-link-input",
      scriptExecuteBehavior.references);
}
  private readonly inputRuleBehavior = new InputRuleBehaviorTranslator();
  private readonly scriptExecuteBehavior = new LinkedScriptExecuteBehaviorTranslator();
  private readonly relationReplacer = new RelationReplacer();
}
